// GraficoEstadosPlugin.js
import GraficoEstado from "./GraficoEstado.vue";
import GraficoEstadoProperties from "./GraficoEstadoProperties.vue";

const GraficoEstadosPlugin = {
  install(Vue) {
    Vue.component("GraficoEstado", GraficoEstado);
    Vue.component("GraficoEstadoProperties", GraficoEstadoProperties);
  },
};

export default GraficoEstadosPlugin;
